import React, {useEffect, useRef} from "react";
import { Player } from 'video-react';
import { connect } from "react-redux";
import $ from 'jquery';

import {toggleNotCompatibleView} from "../../actions/selectionFunctions";
import {toggleShowDescriptionCover} from "../../actions/actionFunctions";
import ActionTypes from "../../misc/actionTypes";

const NotCompatibleView = (props) => {

  const {activePartRelatedItemIndex, windowWidth, activeFeature} = props;
  const player = useRef(null);

  useEffect(() => {
    const isMobile = windowWidth < 991;
    if (!isMobile) {
      player.current.play();
    }
    props.toggleShowDescriptionCover(false);
    return () => {
      props.toggleNotCompatibleView(false); // on unmount component
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    // skip initial render
    return () => {
      props.toggleNotCompatibleView(false); // on unmount component
    }
  }, [activePartRelatedItemIndex]); // eslint-disable-line react-hooks/exhaustive-deps

  const updateDesignButtonClick = () => {
    const navFeature = activeFeature.getParent()
      .navigationSubItems()
      .find(navItem => navItem.part.dbFeature.id === activeFeature.dbFeature.id) // find the real feature
    if (navFeature) { // just in case
      navFeature.part.applyFeatureIfNotCompatible(); // first set new rules for this feature
      navFeature.part.handleClick(); // change item
      $(window).trigger(ActionTypes.UPDATE_ALL_ITEMS); // update footer items
    }
    props.toggleNotCompatibleView(false);  // then remove the view
  }

  const videoPath = "https://intro-videos.s3.amazonaws.com/not-compatible-icon_v1.webm";
  const isMobile = windowWidth < 991;

  return (
    <div className="not-in-visualizer not-in-visualizer--video">
      {isMobile ? null : (
        <div className="not-in-visualizer-video" style={{}}>
          <Player
            ref={player}
            playsInline
            autoPlay={true}
            src={videoPath}
          />
        </div>
      )}
      <span className="not-in-visualizer-title">Not Compatible</span>
      <p className="not-in-visualizer-text">Item is not compatible with current design. Would you like to update your design?</p>
      <p className="not-in-visualizer-button">
        <button className="ui-button2 ui-button2--red" onClick={updateDesignButtonClick}>Update Design</button>
      </p>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {activeFeature, activePartRelatedItemIndex} = store.selectionState;
  return {
    activeFeature,
    activePartRelatedItemIndex,
    windowWidth: store.serverState.windowWidth,
  };
};

const mapDispatchToProps = {
  toggleNotCompatibleView,
  toggleShowDescriptionCover
}

export default connect(mapStateToProps, mapDispatchToProps)(NotCompatibleView);
